var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoppa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.21 126.55",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".coppa_svg__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:18px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coppa_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coppa_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "coppa_svg__cls-1",
    d: "M7.91 3a36.1 36.1 0 1062.4 0M39.11 112.44V57.27M15.45 123.55h47.32M39.11 112.44l10.95 10.95M39.11 112.44l-10.84 10.83"
  })))));
}

var MemoSvgCoppa = /*#__PURE__*/React.memo(SvgCoppa);
export default MemoSvgCoppa;